import {
  Description,
  InformationContainerInner,
  SpondGroupContainer,
  Subheading,
  SubmitButton,
  SvgDotPattern1,
} from "../SpondGroups/SpondGroups.styles";
import {
  InformationContainer,
  Pill,
} from "../welcomeBanner/WelcomeBanner.styled";
import { ReactComponent as SubmitButtonIcon } from "feather-icons/dist/icons/credit-card.svg";

const NewMemberPromptToPay = ({ isAdult, membershipNumber }) => {
  const toMembershipPayment = function () {
    if (isAdult) {
      window.location.href =
        process.env.REACT_APP_SENIORS_PAYMENT_LINK +
        "?client_reference_id=" +
        membershipNumber;
    } else {
      window.location.href =
        process.env.REACT_APP_JUNIORS_PAYMENT_LINK +
        "?client_reference_id=" +
        membershipNumber;
    }
  };

  return (
    <>
      <Pill style={{ backgroundColor: "#f0c1b2" }}>INACTIVE MEMBERSHIP</Pill>
      <InformationContainer>
        <SvgDotPattern1 />
        <InformationContainerInner></InformationContainerInner>
        <Subheading>Activate your membership</Subheading>
        <Description>
          You need to pay your yearly membership fee to become an active member.
          Your membership will last for 12 months from the date of purchase!
          Please note that discount codes are avaiable for students - contact us
          to find out more.
          <br></br>
          <br></br>
          Please note - when you pay you'll be redirected to Stripe to complete
          the purchase.
        </Description>
        <SpondGroupContainer>
          <SubmitButton type="button" onClick={toMembershipPayment}>
            <SubmitButtonIcon className="icon" />
            <span className="text">Pay Membership</span>
          </SubmitButton>
        </SpondGroupContainer>
      </InformationContainer>
    </>
  );
};

export default NewMemberPromptToPay;
